import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import Layout from "@/themes";
import Dashboard from "../pages/Dashboard.vue";
import NotFound from "../pages/NotFound.vue";

// Módulos
import { publicRoutes as userPublicRoutes, protectedRoutes as userProtectedRoutes } from "@/modules/Users/routes";
import { protectedRoutes as logsProtectedRoutes } from "@/modules/SystemLogs/routes";
import { protectedRoutes as settingsProtectedRoutes } from "@/modules/Settings/routes";
import { protectedRoutes as documentProtectedRoutes } from "@/modules/Documents/routes";
import { protectedRoutes as auditProtectedRoutes } from "@/modules/Audit/routes";
import loansRoutes from "@/modules/Loans/router";
import documentListsRoutes from "@/modules/DocumentLists/router";
import reproductionsRoutes from "@/modules/Reproductions/router";
import publicationsRoutes from "@/modules/Publications/router";
import { publicRoutes as authPublicRoutes } from "@/modules/Auth/routes";
import statisticsRoutes from "@/modules/Statistics/router";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      component: Layout,
      children: [
        {
          path: "/",
          name: "dashboard",
          component: Dashboard,
        },
        ...userProtectedRoutes,
        ...logsProtectedRoutes,
        ...settingsProtectedRoutes,
        ...documentProtectedRoutes,
        ...auditProtectedRoutes,
        ...loansRoutes,
        ...documentListsRoutes,
        ...reproductionsRoutes,
        ...publicationsRoutes,
        ...statisticsRoutes,
      ],
      meta: { requiresAuth: true },
    },
    ...userPublicRoutes,
    ...authPublicRoutes,
    {
      path: "/:pathMatch(.*)*",
      name: "not-found",
      component: NotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next({ name: "login" });
  } else if (to.meta.requiresAdmin && authStore.user?.role !== 'ADMIN') {
    next({ name: "dashboard" });
  } else if (to.meta.guestOnly && authStore.isAuthenticated) {
    next({ name: "dashboard" });
  } else {
    next();
  }
});

export default router;
